<template>
  <div id="app" :class="{'is-locked': isMenuOpened}">
    <Header />
    <router-view/>
  </div>
</template>

<style>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #000000;
  overflow-x: hidden;
}
#app.is-locked {
  position: fixed;
  overflow: hidden;
  width: 100%;
}
</style>
<script>
  import { mapState } from 'vuex'
  import Header from "./components/Header/Header";

  export default {
    components: {Header},
    computed: {
      ...mapState([
        'isMenuOpened'
      ])
    },
  }
</script>
